import type {
  AlarmCategory,
  AlarmCodeDef,
  AlarmTypeDef,
  CatKey,
  DeviceGroup,
  DeviceGroupKey,
  PollCfg,
  PushCfg,
  ReceiverGroup,
} from './types'

export const alarmCategories: AlarmCategory[] = [
  { key: 'power', name: '功率异常' },
  { key: 'comm', name: '通信异常' },
  { key: 'volt', name: '电压异常' },
  { key: 'temp', name: '温度异常' },
]

export const allAlarmTypes: AlarmTypeDef[] = [
  { code: 'A0_00_03_0001', name: '逆流告警', cat: 'power', desc: '功率反送电网，逆流值超过阈值并持续一定时间' },
  { code: 'A0_00_03_0002', name: '超需量告警', cat: 'power', desc: '实时用电功率超过合同申报的最大需量值' },
  { code: 'A0_00_03_0003', name: '非计划停机', cat: 'power', desc: '储能设备在策略执行时段内非预期停机' },
  { code: 'A0_00_04_0001', name: '整站离线', cat: 'comm', desc: '整个电站数据采集中断，所有设备无数据上报' },
  { code: 'A0_00_04_0002', name: '设备离线', cat: 'comm', desc: '单个 elink / eBlock / 电表通讯中断超过阈值' },
  { code: 'A0_00_04_0003', name: '并网柜失压', cat: 'comm', desc: '并网柜三相电压同时低于安全阈值' },
  { code: 'A0_00_05_0001', name: '电芯压差超限', cat: 'volt', desc: '同一 eBlock 内电芯间最大压差超过阈值' },
  { code: 'A0_00_05_0002', name: '电芯过压', cat: 'volt', desc: '单颗电芯电压超过安全上限' },
  { code: 'A0_00_05_0003', name: '电芯欠压', cat: 'volt', desc: '单颗电芯电压低于安全下限' },
  { code: 'A0_00_06_0001', name: '温差告警', cat: 'temp', desc: '电芯间或PACK间温差超过阈值' },
  { code: 'A0_00_06_0002', name: '最高温度超限', cat: 'temp', desc: '电芯或PACK温度超过安全上限' },
]

// 电站告警码：按设备/子系统分组的原始告警码定义
export const deviceGroups: DeviceGroup[] = [
  { key: 'eBlock', name: 'eBlock ', icon: 'mdi-block' },
  { key: 'eLink', name: 'eLink', icon: 'mdi-link' },
  { key: 'BCS', name: 'BCS', icon: 'mdi-fire' },
  { key: 'BMS', name: 'BMS ', icon: 'mdi-battery-charging-high' },
  { key: 'PCS', name: 'PCS ', icon: 'mdi-sine-wave' },
  { key: 'EMS', name: 'EMS ', icon: 'mdi-cpu-64-bit' },
  { key: 'Fire', name: 'Fire', icon: 'mdi-fire' },
  { key: 'Water', name: 'Water', icon: 'mdi-fire' },
  { key: '100C-DCDC', name: '100C-DCDC', icon: 'mdi-fire' },
  { key: '100C-MPPT', name: '100C-MPPT', icon: 'mdi-fire' },
]

export const allAlarmCodes: AlarmCodeDef[] = [

]

export const channelOptions = [
  { value: 'supervisor', label: '企业微信 Supervisor' },
  { value: 'app', label: '企业微信 App' },
  { value: 'web', label: '企业微信 Web' },
]

// 推送间隔初始数据
export function createPushIntervals(): PushCfg[] {
  return [
    { code: 'A0_00_03_0001', name: '逆流告警', interval: 10, defaultVal: 10, cat: 'power' },
    { code: 'A0_00_03_0002', name: '超需量告警', interval: 10, defaultVal: 10, cat: 'power' },
    { code: 'A0_00_03_0003', name: '非计划停机', interval: 10, defaultVal: 10, cat: 'power' },
    { code: 'A0_00_04_0001', name: '整站离线', interval: 60, defaultVal: 60, cat: 'comm' },
    { code: 'A0_00_04_0002', name: '设备离线', interval: 60, defaultVal: 60, cat: 'comm' },
    { code: 'A0_00_04_0003', name: '并网柜失压', interval: 10, defaultVal: 10, cat: 'comm' },
    { code: 'A0_00_05_0001', name: '电芯压差超限', interval: 10, defaultVal: 10, cat: 'volt' },
    { code: 'A0_00_05_0002', name: '电芯过压', interval: 10, defaultVal: 10, cat: 'volt' },
    { code: 'A0_00_05_0003', name: '电芯欠压', interval: 10, defaultVal: 10, cat: 'volt' },
    { code: 'A0_00_06_0001', name: '温差告警', interval: 10, defaultVal: 10, cat: 'temp' },
    { code: 'A0_00_06_0002', name: '最高温度超限', interval: 10, defaultVal: 10, cat: 'temp' },
  ]
}

// 轮询间隔初始数据
export function createPollIntervals(): PollCfg[] {
  return [
    { job: 'comm', name: '通信状态检查', interval: 60, defaultVal: 60, desc: 'PollingMapper → Redis' },
    { job: 'cabinet', name: '并网柜失压检测', interval: 10, defaultVal: 10, desc: 'VoltagePollingMapper → Redis' },
    { job: 'demand', name: '需量/逆流/停机检测', interval: 10, defaultVal: 10, desc: 'DemandBackflowPollingProcess → Redis' },
    { job: 'volt', name: '电芯电压差检测', interval: 60, defaultVal: 60, desc: 'RealtimeVoltDiffJob → TDengine' },
    { job: 'temp', name: '温度超限检测', interval: 60, defaultVal: 60, desc: 'RealtimeTempHighJob → TDengine' },
  ]
}

// 接收组初始数据
export function createGroups(): ReceiverGroup[] {
  return [
    {
      id: 'g1',
      name: '功率运维组',
      members: ['CHENWEI', 'ZHANGQIANG', 'LIUYAN'],
      stations: ['233', '619', '101'],
      channels: { supervisor: true, app: true, web: false },
      _newMember: '',
    },
    {
      id: 'g2',
      name: '通信运维组',
      members: ['LIGUANG', 'ZHOUTAO', 'WANGFANG', 'CHENXIAO'],
      stations: ['17', '117', '205'],
      channels: { supervisor: true, app: false, web: true },
      _newMember: '',
    },
    {
      id: 'g3',
      name: '电池安全组',
      members: ['SUNYU', 'HUANGJIE', 'WUXIN'],
      stations: ['308', '412', '233'],
      channels: { supervisor: true, app: true, web: true },
      _newMember: '',
    },
    {
      id: 'g4',
      name: '综合运维组',
      members: ['CHENWEI', 'LIGUANG', 'SUNYU', 'LIUYAN'],
      stations: ['619', '205', '101', '17'],
      channels: { supervisor: true, app: false, web: false },
      _newMember: '',
    },
  ]
}

// 每电站的告警开关初始状态
export function createStationAlarmsMap(): Record<string, Record<string, boolean>> {
  return {
    '233': {
      A0_00_03_0001: true,
      A0_00_03_0002: true,
      A0_00_03_0003: true,
      A0_00_04_0001: true,
      A0_00_04_0002: true,
      A0_00_04_0003: true,
      A0_00_05_0001: false,
      A0_00_05_0002: false,
      A0_00_05_0003: true,
      A0_00_06_0001: true,
      A0_00_06_0002: true,
    },
    '619': {
      A0_00_03_0001: true,
      A0_00_03_0002: true,
      A0_00_03_0003: true,
      A0_00_04_0001: true,
      A0_00_04_0002: true,
      A0_00_04_0003: true,
      A0_00_05_0001: true,
      A0_00_05_0002: true,
      A0_00_05_0003: true,
      A0_00_06_0001: true,
      A0_00_06_0002: true,
    },
    '101': {
      A0_00_03_0001: true,
      A0_00_03_0002: true,
      A0_00_03_0003: false,
      A0_00_04_0001: true,
      A0_00_04_0002: true,
      A0_00_04_0003: true,
      A0_00_05_0001: true,
      A0_00_05_0002: true,
      A0_00_05_0003: true,
      A0_00_06_0001: true,
      A0_00_06_0002: true,
    },
    '17': {
      A0_00_03_0001: true,
      A0_00_03_0002: true,
      A0_00_03_0003: true,
      A0_00_04_0001: true,
      A0_00_04_0002: true,
      A0_00_04_0003: true,
      A0_00_05_0001: true,
      A0_00_05_0002: true,
      A0_00_05_0003: true,
      A0_00_06_0001: true,
      A0_00_06_0002: true,
    },
    '117': {
      A0_00_03_0001: true,
      A0_00_03_0002: true,
      A0_00_03_0003: true,
      A0_00_04_0001: true,
      A0_00_04_0002: false,
      A0_00_04_0003: true,
      A0_00_05_0001: true,
      A0_00_05_0002: true,
      A0_00_05_0003: true,
      A0_00_06_0001: false,
      A0_00_06_0002: false,
    },
    '205': {
      A0_00_03_0001: true,
      A0_00_03_0002: false,
      A0_00_03_0003: true,
      A0_00_04_0001: true,
      A0_00_04_0002: true,
      A0_00_04_0003: true,
      A0_00_05_0001: true,
      A0_00_05_0002: true,
      A0_00_05_0003: true,
      A0_00_06_0001: true,
      A0_00_06_0002: true,
    },
    '308': {
      A0_00_03_0001: true,
      A0_00_03_0002: true,
      A0_00_03_0003: true,
      A0_00_04_0001: true,
      A0_00_04_0002: true,
      A0_00_04_0003: false,
      A0_00_05_0001: true,
      A0_00_05_0002: true,
      A0_00_05_0003: true,
      A0_00_06_0001: true,
      A0_00_06_0002: true,
    },
    '412': {
      A0_00_03_0001: true,
      A0_00_03_0002: true,
      A0_00_03_0003: true,
      A0_00_04_0001: true,
      A0_00_04_0002: true,
      A0_00_04_0003: true,
      A0_00_05_0001: true,
      A0_00_05_0002: true,
      A0_00_05_0003: false,
      A0_00_06_0001: true,
      A0_00_06_0002: true,
    },
  }
}

// 每电站的告警码开关初始状态；未配置的电站默认全部启用
export function createStationCodesMap(): Record<string, Record<string, boolean>> {
  return {
    '233': { PCS_0x1003: false, HVAC_0x3003: false },
    '619': { BMS_0x0301: false },
    '117': { FIRE_0x4003: false, EMS_0x2003: false },
    '205': { PCS_0x1002: false },
  }
}

export function categoryAlarms(k: CatKey) {
  return allAlarmTypes.filter((a) => a.cat === k)
}

export function codeGroupAlarms(k: DeviceGroupKey) {
  return allAlarmCodes.filter((c) => c.group === k)
}

export function formatMinutesTooltip(v: number) {
  return `${v} 分钟`
}

export function formatSecondsTooltip(v: number) {
  return `${v} 秒`
}
